import { forwardRef } from 'react'

import * as S from './select-label.styles'

import { DISPLAY_NAME, useSelectContext } from '../../input-select'

import type { ScopedProps } from '../../input-select.types'

type SelectLabelProps = React.ComponentPropsWithoutRef<typeof S.Label> & {}
type SelectLabelElementRef = React.ElementRef<typeof S.Label>

const SelectLabel = forwardRef<SelectLabelElementRef, SelectLabelProps>(
  (props, ref) => {
    const { __scopeSelect } = props as ScopedProps<SelectLabelProps>

    const { isDisabled, isReadOnly, isError, size } = useSelectContext(
      DISPLAY_NAME,
      __scopeSelect
    )

    const accessibilityLabel = props.children?.toString()

    const labelDefaultProps = {
      ellipsizeMode: 'tail',
      numberOfLines: 1,
      allowFontScaling: true,
      'aria-label': accessibilityLabel,
      accessibilityLabel,
    } satisfies SelectLabelProps

    const selectLabelStates = {
      size,
      isDisabled,
      isReadOnly,
      isError,
    }

    return (
      <S.Label
        {...props}
        {...labelDefaultProps}
        {...selectLabelStates}
        ref={ref}
      />
    )
  }
)

SelectLabel.displayName = 'SelectLabel'

export { SelectLabel }
